import client, { API_BASE_URL } from './client';

export async function getBrandList() {
  const res = await client.get('/admin/brand');
  return res.data;
}

export async function getBrand(brandId) {
  const res = await client.get(`/admin/brand/${brandId}`);
  return res.data;
}

export async function createBrand(payload) {
  const res = await client.post('/admin/brand', payload);
  return res.data;
}

export async function updateBrand(brandId, payload) {
  const res = await client.put(`/admin/brand/${brandId}`, payload);
  return res.data;
}

export async function deleteBrand(brandId) {
  const res = await client.delete(`/admin/brand/${brandId}`);
  return res.data;
}

// 브랜드 로고/대표 이미지는 front-web QR 브랜드소개 화면에서도 <img> 로 열람하므로 백엔드에서 공개돼 있다.
export function getBrandLogoUrl(brandId) {
  return `${API_BASE_URL}/admin/brand/${brandId}/logo`;
}

export function getBrandMainUrl(brandId) {
  return `${API_BASE_URL}/admin/brand/${brandId}/main`;
}

export async function uploadBrandLogo(brandId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/brand/${brandId}/logo`, formData);
  return res.data;
}

export async function uploadBrandMain(brandId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/brand/${brandId}/main`, formData);
  return res.data;
}
